import { useState } from 'react';
import type { Storyline } from '../lib/api';

const TONE: Record<string, string> = {
  revenge: 'bg-redTint text-red', primetime: 'bg-blueTint text-blueDark', divisional: 'bg-amberTint text-amber',
  weather: 'bg-wash text-muted', regression: 'bg-greenTint text-green', trend: 'bg-blueTint text-blueDark',
};

/** Pull the first number out of the data point so the card leads with a figure. */
function headline(s: string): string | null {
  const m = s.match(/-?\d+(?:\.\d+)?%?/);
  return m ? m[0] : null;
}

export function NarrativeCard({ s }: { s: Storyline }) {
  const [open, setOpen] = useState(false);
  const big = headline(s.data_point);
  return (
    <article className="card flex flex-col p-4">
      <div className="flex items-center justify-between gap-3">
        <span className={`pill ${TONE[s.type] ?? 'bg-wash text-muted'}`}>{s.type}</span>
        {s.betting_relevance === 'high' && <span className="pill bg-blue text-paper">Key</span>}
      </div>
      {big && <p className="score mt-3 text-[46px] leading-none text-blue">{big}</p>}
      <p className="h3 mt-1.5">{s.title}</p>
      <p className="mt-2 text-[13px] leading-relaxed text-muted">{s.data_point}</p>
      <button onClick={() => setOpen(!open)} className="mt-3 self-start font-cond text-[14px] font-semibold uppercase tracking-[0.08em] text-blue hover:text-blueDark">{open ? 'Hide' : 'Why it matters'}</button>
      {open && <p className="mt-2 text-[14px] leading-relaxed text-ink animate-fadeIn">{s.why_it_matters}</p>}
      {s.small_sample && <span className="mono-label mt-3">Small sample</span>}
    </article>
  );
}
